import { Form, Radio, Select } from 'antd'
import { RoleSelect } from '@/features/authorization/role-select.tsx'
import { MemberFormFields } from './member-form-fields.tsx'

type EmployeeOption = {
  id: number
  email: string | null
  isSalesperson: boolean
  jobTitle: string | null
  name: string
}

export function ApplicationReviewFields({
  approvePending,
  employees,
  employeesLoading,
  memberMode,
  requiresSalesperson
}: {
  approvePending: boolean
  employees?: EmployeeOption[]
  employeesLoading: boolean
  memberMode?: 'create' | 'existing'
  requiresSalesperson: boolean
}) {
  return (
    <>
      <Form.Item
        colon={false}
        label="成员处理方式"
        labelCol={{ flex: '0 0 auto' }}
        layout="horizontal"
        name="memberMode"
        wrapperCol={{ flex: '1 1 auto' }}
      >
        <Radio.Group
          options={[
            { label: '绑定已有员工', value: 'existing' },
            { label: '创建新成员', value: 'create' }
          ]}
        />
      </Form.Item>
      {memberMode === 'create' ? (
        <MemberFormFields
          disabled={approvePending}
          emailDisabled
          notePlaceholder="补充任职或审核信息"
          salespersonRequired={requiresSalesperson}
          typeDisabled
          typeOptions={[{ label: '内部员工', value: 'employee' }]}
        />
      ) : (
        <Form.Item
          label="已有员工"
          name="memberId"
          rules={[
            { message: '请选择员工', required: true },
            ...(requiresSalesperson
              ? [
                  {
                    validator: (_rule: unknown, value: number | undefined) => {
                      const selected = employees?.find((member) => member.id === value)
                      return selected?.isSalesperson
                        ? Promise.resolve()
                        : Promise.reject(new Error('请选择已启用业务员身份的成员'))
                    }
                  }
                ]
              : [])
          ]}
        >
          <Select
            loading={employeesLoading}
            options={employees?.map((member) => ({
              label: `${member.name} · ${member.email ?? '未填写邮箱'}${member.jobTitle ? ` · ${member.jobTitle}` : ''}${member.isSalesperson ? ' · 业务员' : ''}`,
              value: member.id
            }))}
            placeholder="选择未绑定账号的员工…"
            showSearch={{ optionFilterProp: 'label' }}
          />
        </Form.Item>
      )}
      <Form.Item
        label="账号角色"
        name="roleIds"
        rules={[{ message: '至少选择一个角色', min: 1, required: true, type: 'array' }]}
      >
        <RoleSelect disabled={approvePending} />
      </Form.Item>
    </>
  )
}
